import React, {useState, useEffect, useRef} from 'react';
import ReactDOM from 'react-dom';
import {
    View,
} from 'react-native';
import HMIcon from "../../HMIcon";
import Colors from "../../../tools/Colors";
import {moderateScale} from "../../../tools/Scaling";
import * as NavigationService from "../../../redux/NavigationService";
import HMTextView from "../../HMTextView";
import {Tools} from "../../../tools/Tools";

let stream = null;
let url = null;
let blob = null;

const MediaRecorderCapture = props => {
    //console.log("fileSelect",props)
    const [mediaRecorder, setMediaRecorder] = useState({});
    const [timeRecorder, setTimeRecorder] = useState(0);
    const [facingMode, setFacingMode] = useState("environment");
    const [isRecording, setIsRecording] = useState(false);
    //const [pathVideo, setPathVideo] = useState(null);
    const [isDone, setIsDone] = useState(false);
    const recorderRef = useRef();
    const playerRef = useRef();
    const tick = useRef();
    /**
     * Initialize the MediaRecorder on component mount
     */
    useEffect(() => {
        initializeMediaRecorder();

        //exitRecord();
        return () => {
            console.log('componentWillUnmount', stream);
            exitRecord();

        };


    }, [])


    /**
     * Helper function to console out change in state of the MediaRecorder
     */
    useEffect(() => {
        console.log(`MediaRecorder state: ${mediaRecorder.state}`)
    }, [mediaRecorder.state])

    /**
     * Start recording the stream
     */
    const start = async () => {
        setTimeRecorder(0);

        if (mediaRecorder.state === 'recording') return;

        !stream && await initializeMediaRecorder();

        mediaRecorder.start();
        setIsRecording(true);
        setIsDone(false);
    }

    const exitRecord = () => {
        //if (!(mediaRecorder.state) ) return;
        if (!stream) return;
        stream.getTracks().forEach(function (track) {
            track.stop();
            stream = null;
        });

    }

    /**
     * Stop recording the stream
     */
    const stop = async () => {
        if (mediaRecorder.state === 'inactive') return;
        mediaRecorder.stop();
        setIsRecording(false);
        setIsDone(true);
    }
    /**
     * Upon MedaRecorder being set, monitor the following events
     */
    useEffect(() => {
        let chunks = [];

        mediaRecorder.ondataavailable = e => chunks.push(e.data)

        mediaRecorder.onstop = e => {
            blob = new Blob(chunks, {type: 'video/mp4'});
            chunks = [];
            url = (window.URL || window.webkitURL).createObjectURL(blob);
            Tools.copyClipboardWeb(url)

            //setPathVideo(url);
            setPlaybackPreview(url);
          //  createDownloadLink(url);

        }

        mediaRecorder.onerror = e => {
            console.log('Error recording stream');
            console.log(e.error);
        }

        console.log('MediaRecorder ready');
        if (isRecording) {
            if (timeRecorder <= 60) {
                tick.current = setInterval(() => { // <-- set tick ref current value
                    setTimeRecorder((timer) => timer + 1);
                }, 1000);
            } else {
                stop();
                clearInterval(tick.current); // <-- access tick ref current value
            }
        }


        return () => clearInterval(tick.current); // <-- clear on unmount!


    }, [mediaRecorder, timeRecorder, isRecording]);

    const createDownloadLink = url => {
        const link = <a href={url} download="Recording.mp4">Download</a>;
        const linkContainer = document.getElementById('download-link');
        ReactDOM.render(link, linkContainer);
    }
    /**
     * Set the playback player's source to the url of the newly recorderd stream
     * @param {string} url
     */
    const setPlaybackPreview = url => {
        if (!playerRef.current) return;
        console.log(`Playback URL: ${url}`);
        playerRef.current.src = url;
    }

    /**
     * Get a media device stream (webcam)
     */
    const getStream = (facingMode) => {
        return new Promise(async (resolve, reject) => {
            try {
                stream = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: {
                        // facingMode: 'user'
                        //    facingMode: 'environment'
                        facingMode: facingMode ? facingMode : "environment"

                        // facingMode: { exact: "user" }
                        //   facingMode:{exact: "environment"}
                    }
                });
                console.log('Stream fetched');
                resolve(stream);
            }
            catch (err) {
                console.log('Error in fetching stream')
                reject(err);
            }
        })
    }

    /**
     * Set the live stream retrieved from the media device
     * to the designated player to preview
     * @param {object} stream
     */
    const setRecordingStreamPreview = stream => {
        if (!recorderRef.current) return;
        recorderRef.current.srcObject = stream;
    }

    /**
     * Create MediaRecorder object from a given stream
     * @param {object} stream
     */
    const createMediaRecorder = stream => {
        return new Promise((resolve, reject) => {
            try {
                var containerType = "video/webm";
                if (MediaRecorder.isTypeSupported('video/webm;codecs=h264')) {
                    var options = {mimeType: 'video/webm;codecs=h264'};
                } else if (MediaRecorder.isTypeSupported('video/webm')) {

                    var options = {mimeType: 'video/webm'};
                } else if (MediaRecorder.isTypeSupported('video/mp4')) {

                    //Safari 14.0.2 has an EXPERIMENTAL version of MediaRecorder enabled by default
                    containerType = "video/mp4";
                    var options = {
                        mimeType: 'video/mp4',
                        videoBitsPerSecond: 2500000,
                        // facingMode: {exact: "environment"}
                    };
                }


                const mediaRecorder = new MediaRecorder(stream, options);


                // const mediaRecorder = new MediaRecorder(stream);

                console.log('New MediaRecorder created');
                resolve(mediaRecorder);
            }
            catch (err) {
                console.log('Error in creating new MediaRecorder');
                reject(err);
            }
        })
    }

    /**
     * Initialize MediaRecorder
     */
    const initializeMediaRecorder = async (facingMode) => {
        return new Promise(async (resolve, reject) => {
            try {
                stream = await getStream(facingMode);
                setRecordingStreamPreview(stream);
                const mediaRecorder = await createMediaRecorder(stream);
                setMediaRecorder(mediaRecorder);
                resolve(mediaRecorder);
            }
            catch (err) {
                console.log('Error in initializing MediaRecorder of fetching media devices stream')
                reject(err);
            }
        })
    }
    return (
        <View style={{
            width: '100%',
        }}>

            <View style={{
                maxWidth: '100%',
                alignSelf: 'center',
                //  alignItems: 'center',
                // justifyContent: "center"

                //height: moderateScale(200)
            }}>
                <video
                    className="recorder"
                    ref={recorderRef}
                    autoPlay
                    playsinline
                    muted
                />
                <View style={{
                    width: '100%',

                    position: "absolute",
                    bottom: 0,
                }}>
                    <View style={{
                        flexDirection: "row-reverse",

                        width: "100%",
                        justifyContent: "space-between",
                        backgroundColor: Colors.gray,
                    }}>
                        <View
                            style={{
                                flex: 1,
                                flexDirection: "row-reverse",
                                paddingHorizontal: moderateScale(10)
                            }}
                        >
                            <HMTextView
                                text={Tools.getTimeStringM(timeRecorder)}
                                type={'bold'}
                                style={{
                                    alignSelf: 'center',
                                    //  marginRight: moderateScale(6),
                                    // margin: moderateScale(6),
                                    textAlign: 'center',
                                    color: Colors.colorDarkText,
                                    fontSize: moderateScale(14),
                                }}/>
                            {
                                isDone &&
                                <HMIcon
                                    //type={"bold"}
                                    onPress={() => {
                                        props.route.params.fileSelect({_pathVideo: blob}, "video")
                                        NavigationService.Pop();
                                        // stream.getTracks().forEach(function (track) {
                                        //     track.stop();
                                        //     stream = null;
                                        // });
                                    }
                                    }
                                    type={"AntDesign"}
                                    name={'check'} style={{
                                    color: "#179621",
                                    fontSize: moderateScale(28),
                                    padding: moderateScale(2),
                                    // alignSelf: "center",
                                    //  textAlign: "center",
                                }}/>
                            }

                            <HMIcon
                                //type={"bold"}
                                onPress={isRecording ? stop : start}
                                type={"MaterialCommunityIcons"}
                                name={isRecording ? 'stop' : 'record-circle'} style={{
                                color: Colors.red,
                                fontSize: moderateScale(28),
                                padding: moderateScale(2),
                                // alignSelf: "center",
                                //  textAlign: "center",
                            }}/>


                        </View>
                        {
                            isRecording?
                            null
                            :
                                <HMIcon
                                    //type={"bold"}
                                    onPress={async () => {
                                        let res = facingMode === "user" ? "environment" : "user";

                                        if (typeof stream !== 'undefined') {
                                            stream.getTracks().forEach(track => {
                                                track.stop();
                                            });
                                        }
                                        await initializeMediaRecorder(res);
                                        setFacingMode(res);
                                        //  await initializeMediaRecorder();
                                        // stream.getTracks().forEach(function (track) {
                                        //     track.stop();
                                        //     stream = null;
                                        // });
                                    }
                                    }
                                    //type={"AntDesign"}
                                    name={'camera-reverse-outline'} style={{
                                    color: Colors.blackLight,
                                    fontSize: moderateScale(28),
                                    padding: moderateScale(2),
                                    // alignSelf: "center",
                                    //  textAlign: "center",
                                }}/>
                        }

                    </View>
                </View>
            </View>
            {/*<div id="download-link"></div>*/}
        </View>
    )
    // return (
    //     <React.Fragment>
    //
    //
    //         <h1>MediaRecorder</h1>
    //         <div>
    //             <button
    //                 onClick={isRecording ? stop : start}
    //                 className={isRecording ? 'recording' : ''}
    //             >{isRecording ? 'Stop' : 'Start'} Recording
    //             </button>
    //         </div>
    //         <div>
    //             <h3>MediaRecorderCapture</h3>
    //             <video
    //                 className="recorder"
    //                 ref={recorderRef}
    //                 autoPlay
    //                 playsInline
    //                 muted
    //             />
    //         </div>
    //         <div>
    //             <h3>Playback</h3>
    //             <video
    //                 className="player"
    //                 controls
    //                 ref={playerRef}
    //                 autoPlay
    //                 playsInline
    //             />
    //         </div>
    //         <div id="download-link"></div>
    //     </React.Fragment>
    // )
}

export default MediaRecorderCapture;
